import { Reducer } from "redux";
import { ActionTypes } from "./action-types";
import { FavoriteAction } from "./actions";

export interface IFavoriteState {
    isLoading: boolean;
    items: Spintr.IUserFavorite[];
}

const initialState: IFavoriteState = {
    isLoading: false,
    items: [],
};

export const favoriteReducer: Reducer<IFavoriteState, FavoriteAction> = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.FetchUserFavoritesPending:
            return {
                ...state,
                isLoading: true,
            };

        case ActionTypes.FetchUserFavoritesRejected:
            return {
                ...state,
                isLoading: false,
            };
        case ActionTypes.FetchUserFavoritesFulfilled:
            return {
                ...state,
                isLoading: false,
                items: action.payload.data,
            };

        default:
            return state;
    }
};
